import { render, staticRenderFns } from "./CustomerZipGroup.vue?vue&type=template&id=0c302076&scoped=true&"
import script from "./CustomerZipGroup.vue?vue&type=script&lang=js&"
export * from "./CustomerZipGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerZipGroup.vue?vue&type=style&index=0&id=0c302076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c302076",
  null
  
)

export default component.exports